import { render, staticRenderFns } from "./ComposantePrix.vue?vue&type=template&id=1cd2a5e4&"
import script from "./ComposantePrix.vue?vue&type=script&lang=js&"
export * from "./ComposantePrix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports